import { formatNumber } from "accounting"
import { Space, Typography } from "antd"
import dayjs from "dayjs"

import Private from "../../../../Components/Private"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import Icon from "../../../../Icon"
import { dateFormat } from "../../../../Utils/utils"
import ChannelTag from "../../../DeflectAnalyticsPage/components/ChannelTag"
import { PROGRAM_CARD_META } from "../../constants/receipt-status-mapping"

const { Text } = Typography

const renderAmount = (value) =>
  value == null ? "—" : <Private>{"$" + formatNumber(value, 2, ",")}</Private>

const renderDate = (value) => {
  if (!value) return "—"
  return (
    <Space direction="vertical" size={0}>
      <Text>{dayjs(value).format(dateFormat)}</Text>
      <Text type="secondary" style={{ fontSize: 12 }}>
        {dayjs(value).format("h:mm A")}
      </Text>
    </Space>
  )
}

export const receiptColumnIconMap = {
  date: "calendar_days",
  card: "card",
  channel: "processor",
  program: "processor",
  amount: "money",
  fee_charged: "money"
}

const COLUMN_LABEL = {
  date: "Date",
  card: "Card",
  channel: "Channel",
  program: "Program",
  amount: "Amount",
  fee_charged: "Fee charged"
}

const COLUMN_DATA_INDEX = {
  date: "date",
  card: "card",
  channel: "channel",
  program: "program",
  amount: "amount",
  fee_charged: "fee_charged"
}

const COLUMN_MIN_WIDTH = {
  date: 160,
  card: 140,
  channel: 140,
  program: 140,
  amount: 140,
  fee_charged: 140
}

const buildTitle = (fieldId, t) => (state) =>
  titleSortFilters({
    title: t(COLUMN_LABEL[fieldId]),
    sorter: true,
    icon: receiptColumnIconMap[fieldId],
    stateData: state,
    key: COLUMN_DATA_INDEX[fieldId]
  })

export const getColumns = ({ t }) => ({
  date: {
    key: "date",
    dataIndex: COLUMN_DATA_INDEX.date,
    title: buildTitle("date", t),
    sorter: true,
    defaultSortOrder: "descend", // §BLOCK 4.5 — newest first
    minWidth: COLUMN_MIN_WIDTH.date,
    render: renderDate
  },
  card: {
    key: "card",
    dataIndex: COLUMN_DATA_INDEX.card,
    title: buildTitle("card", t),
    sorter: true,
    minWidth: COLUMN_MIN_WIDTH.card,
    render: (last4) => (last4 ? <Private>{last4}</Private> : "—")
  },
  channel: {
    key: "channel",
    dataIndex: COLUMN_DATA_INDEX.channel,
    title: buildTitle("channel", t),
    sorter: true,
    minWidth: COLUMN_MIN_WIDTH.channel,
    // The same tag and colours as Deflect Analytics, so a channel reads the same on both pages (CHA1-4949).
    render: (value) => <ChannelTag value={value} />
  },
  program: {
    key: "program",
    dataIndex: COLUMN_DATA_INDEX.program,
    title: buildTitle("program", t),
    sorter: true,
    minWidth: COLUMN_MIN_WIDTH.program,
    render: (value) => {
      const meta = PROGRAM_CARD_META[value]
      if (!meta) return "—"
      return (
        <Space justify={"center"} gap={4}>
          {meta?.iconType && <Icon type={meta.iconType} style={{ fontSize: 20, lineHeight: 1 }} />}
          <Text strong>{meta?.label}</Text>
        </Space>
      )
    }
  },
  amount: {
    key: "amount",
    dataIndex: COLUMN_DATA_INDEX.amount,
    title: buildTitle("amount", t),
    sorter: true,
    minWidth: COLUMN_MIN_WIDTH.amount,
    render: renderAmount
  },
  fee_charged: {
    key: "fee_charged",
    dataIndex: COLUMN_DATA_INDEX.fee_charged,
    title: buildTitle("fee_charged", t),
    sorter: true,
    minWidth: COLUMN_MIN_WIDTH.fee_charged,
    render: renderAmount
  }
})
